import { actionsviewer } from "./classes/actionsviewer";
import { urls } from './classes/urls';
import { configEnviroment } from './resources/config';
import { lang } from './resources/lang';

var lsViewer = {

  actions: actionsviewer,
  lang: {
    langObject: lang
  },
  url: urls,
  config: configEnviroment
};
window.lsViewer = lsViewer;

$(window).on('resize', function () {

  lsViewer.actions.resize();

});
